import { render, staticRenderFns } from "./TemplateListItem.vue?vue&type=template&id=5dd108f7&scoped=true"
import script from "./TemplateListItem.vue?vue&type=script&lang=ts"
export * from "./TemplateListItem.vue?vue&type=script&lang=ts"
import style0 from "./TemplateListItem.vue?vue&type=style&index=0&id=5dd108f7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd108f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd108f7')) {
      api.createRecord('5dd108f7', component.options)
    } else {
      api.reload('5dd108f7', component.options)
    }
    module.hot.accept("./TemplateListItem.vue?vue&type=template&id=5dd108f7&scoped=true", function () {
      api.rerender('5dd108f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/lists/TemplateListItem.vue"
export default component.exports